import { Button, Empty } from "antd";

export default function whiteScreenFallback() {
  // Call resetErrorBoundary() to reset the error boundary and retry the render.
  return (
    <div className="mt-5">
      <Empty
        description={
          <p>
            Oops!!! Something went wrong <br /><br />
            Please click on the <b>Reload</b> button to return back to your home screen.
          </p>
        }
      >
        <Button className="mt-4 bg-primary" color="primary" variant="solid" onClick={() => { window.location.href = "/login" }}>Reload</Button>
      </Empty>
    </div>
  );
}
